<template>
  <div class="payResultWrap">
    <div
      v-if="status==='success'"
      class="payResultBox"
    >
      <div class="resultImg">
        <img
          :src="require('@/assets/images/order/paySuccess.png')"
          alt=""
        />
      </div>
      <p class="resultStatus">
        {{TLang('支付成功','orderConfirm')}}
      </p>
      <!-- 福拼拼需求统一去掉金额展示 -->
      <!-- <p class="resultStatus padt6">
        <span class="pay">{{TLang('实付','orderConfirm')}}</span>
        <img
          :src="union_icon || require('@/assets/images/fudou.png')"
          alt="fudou"
          class="fudou-15"
        />
        {{ amount }}
      </p> -->
      <div class="btnGroup">
        <Button
          class="btn"
          @click="goHome"
        >
          {{ TLang('继续逛逛','list') }}
        </Button>
        <Button
          class="btn activeBtn"
          @click="goOrderList"
        >
          {{ TLang('查看订单','orderConfirm') }}
        </Button>
      </div>
    </div>
    <div
      v-else
      class="payResultBox"
    >
      <div class="resultImg">
        <img
          :src="require('@/assets/images/order/payFail.png')"
          alt=""
        />
      </div>
      <p class="resultStatus">
        {{ TLang('支付失败','orderConfirm') }}
      </p>
      <p class="resultDesc">
        {{ TLang('payerror','orderConfirm') }}
      </p>
      <div class="btnGroup">
        <Button
          class="btn"
          @click="goOrderList"
        >
          {{ TLang('查看订单','orderConfirm') }}
        </Button>
      </div>
    </div>
  </div>
</template>
<script>

import { unionFlag } from '@utils';
import { doValidate } from '@fetch/index';
const PAGE = {
  orderListFlag: false,
};
export default {
  name: 'OrderPayStatus',
  props: {

  },
  data() {
    return {
      status:this.$route.query.status || 'success',
      amount:this.$route.query.amount || 0,
    };
  },
  computed:{

  },
  created() {
    doValidate().then(res => {
      if (res.code === 200) {
        PAGE.orderListFlag = res.data;
      };
    });
  },
  methods: {
    goOrderList(){
      // 去域名化，SDK修复百福得百福得和官网裸机
      if (window.df_sdk_common && window.df_sdk_common.isBfd()) {
        // 订单统一切新聚合订单
        window.location.href = '/bfd-pc/usercenter/aggregate-order';
      } else {
        if (PAGE.orderListFlag) {
          window.df_sdk_common.location.href = window.location.origin + '/unitedorder';
        } else {
          this.$router.push('/order/list');
        }
      }
    },
    goHome(){
      this.$router.push('/home');
    },
  },
};
</script>
<style lang="less" scoped>
.payResultWrap{
  margin-top: 50px;
 text-align: center;
 .resultImg{
  width: 375px;
    height: 158px;
    margin: 0 auto 20px;
    img{
        width: 100%;
    }
 }
 .resultStatus{
    font-size: 18px;
  
    color: #333333;
    line-height: 25px;
    height: 25px;
  }
  .fudou-15{
    width: 15px;
    height: 15px;
    padding-bottom: 5px;
  }
  .padt6{
    padding-top: 6px;
  }
  .pay{
    font-size: 14px;
    color: #999;
    margin-right: 8px;
  }
  .resultDesc{
    padding-top: 6px;
    font-size: 14px;
  
    color: #999999;
    line-height: 1.5;
  }
  .btnGroup{
    margin-top: 36px;
    display: flex;
    justify-content: center;
    .btn{
      // width: 112px;
      height: 40px;
      padding: 0;
      border-radius: 4px;
      border: 1px solid #E5E5E5;
      line-height: 40px;
      font-size: 14px;
    
      color: #666666;
      width: auto;
      min-width: 112px;
      padding: 0 5px;
    }
    .activeBtn{
      border: none;
      background: linear-gradient(315deg, #5CB4EC 0%, #3D96E2 100%);
    
      font-weight: bold;
      color: #FFFFFF;
    }
    .btn:nth-child(2){
      margin-left: 40px;
    }
  }
}
</style>


